// Redimensiona una imagen (File/Blob) para que ninguno de sus lados
// supere maxSize px, preservando el aspect ratio, y la devuelve como
// Blob JPEG. Si la imagen ya es más chica, no la agranda.
export const redimensionarImagen = (archivo, maxSize = 512, calidad = 0.85) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(archivo);

    img.onload = () => {
      URL.revokeObjectURL(url);

      const escala = Math.min(1, maxSize / Math.max(img.width, img.height));
      const ancho = Math.round(img.width * escala);
      const alto = Math.round(img.height * escala);

      const canvas = document.createElement("canvas");
      canvas.width = ancho;
      canvas.height = alto;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, ancho, alto);

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("No se pudo procesar la imagen."));
            return;
          }
          resolve(blob);
        },
        "image/jpeg",
        calidad,
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("El archivo no es una imagen válida."));
    };

    img.src = url;
  });

// Iniciales para el avatar de respaldo cuando no hay foto. Funciona
// con "Apellido, Nombres" (ej: "Antuña, Ignacio" -> "AI") y también
// con "Nombres Apellido" sin coma (ej: "Ignacio Antuña" -> "IA").
export const inicialesDe = (nombreCompleto) => {
  if (!nombreCompleto) return "?";
  const partes = nombreCompleto
    .split(/[,\s]+/)
    .map((p) => p.trim())
    .filter(Boolean);
  const letras = [partes[0]?.[0], partes[1]?.[0]].filter(Boolean).join("");
  return (letras || nombreCompleto[0] || "?").toUpperCase().slice(0, 2);
};
